import { Company } from '~/interfaces/CompanyConfig';
import { getCompanyByPath, getCompanyOpenIdConfiguration } from './companyUtils';

export function getOpenIdConfiguration(redirectToUrl?: string) {
  const companyType = redirectToUrl ? getCompanyByPath(redirectToUrl) : Company.DEFAULT;
  return getCompanyOpenIdConfiguration(companyType);
}
